export const OPEN_VERIFICATIONS_DIALOG_FLAG = "openVerificationsDialog";
const useOpenVerificationsDialog = () => {
  const shouldOpenVerificationsDialog = useRouteQuery<"false" | "true">(
    OPEN_VERIFICATIONS_DIALOG_FLAG,
    "false",
  );

  return {
    shouldOpenVerificationsDialog,
  };
};

export default createSharedComposable(useOpenVerificationsDialog);
